import { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Typography } from '@mui/material';

interface IEmailConfirmModal {
  open: boolean;
  onConfirm: () => void;
  messageContent: string;
}

export const EmailConfirmModal: FC<IEmailConfirmModal> = ({ open, onConfirm, messageContent }) => {
  return (
    <Dialog open={open} onClose={() => {}} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 2 }}>Confirm Email</DialogTitle>
      <DialogContent sx={{ marginBottom: 5 }}>
        <Typography align="center" mb={6}>
          {messageContent}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onConfirm}
          sx={{
            textTransform: 'none',
            borderRadius: '5px',
            fontWeight: 500,
            backgroundColor: '#3f51b5',
            '&:hover': { backgroundColor: '#354497' },
          }}>
          Continue to Target
        </Button>
      </DialogContent>
    </Dialog>
  );
};
